// src/index.tsx (ou index.jsx / index.tsx)
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './presentation/App';
import { store } from './application/states/store'
import { Provider } from 'react-redux';
import './presentation/fonts';
import './presentation/assets/css/scroll.css';

// === lógica de reload diário ===
(() => {
  const ONE_DAY = 24 * 60 * 60 * 1000;
  const key = 'lastFullReload';
  const last = localStorage.getItem(key);
  const now = Date.now();

  if (!last || now - parseInt(last, 10) > ONE_DAY) {
    // marca o reload
    localStorage.setItem(key, now.toString());
    // força recarregar do servidor, ignorando cache
    // em alguns navegadores window.location.reload(true) funciona
    // mas como está depreciado, usamos location.href:
    window.location.href = window.location.href;
  }
})();
  
// === bootstrap React ===
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
